import script from "./StatusBadgeComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./StatusBadgeComponent.vue?vue&type=script&lang=ts&setup=true"

import "./StatusBadgeComponent.vue?vue&type=style&index=0&id=944ab670&scoped=true&lang=css"
import "./StatusBadgeComponent.vue?vue&type=style&index=1&id=944ab670&lang=css"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-944ab670"]])

export default __exports__